export default "__VITE_ASSET__p9$AUG2T__"